import axios from "axios"

export const ClaimsService = Object.freeze({
  GetClaimSummaries: function (accountId, userId) {
    let reqUrl = window.appGlobals.API_URL + "Claims/GetClaimSummaries?accountId=" + accountId + "&userId=" + userId
    return axios.get(reqUrl)
  },
  GetClaimDetails: function (accountId, userId, claimNumber) {
    let reqUrl = window.appGlobals.API_URL + "Claims/GetClaimDetails?accountId=" + accountId + "&userId=" + userId + "&claimNumber=" + claimNumber
    return axios.get(reqUrl)
  },
  GetPartImages: function (oemPartCodes) {
    let reqUrl = window.appGlobals.API_URL + "Claims/GetPartImages"
    return axios.post(reqUrl, oemPartCodes)
  },
  SearchClaims: function (accountId, userId, referenceNumber, partNumber) {
    let reqUrl = window.appGlobals.API_URL + "Claims/SearchClaims?accountId=" + accountId + "&userId=" + userId + "&referenceNumber=" + referenceNumber + "&partNumber=" + partNumber
    return axios.get(reqUrl)
  },
  SearchInvoices: function (accountId, userId, searchText, isPartSearch, removeDateRestriction) {
    let reqUrl = window.appGlobals.API_URL + "Claims/SearchInvoices?accountId=" + accountId + "&userId=" + userId + "&searchText=" + searchText + "&isPartSearch=" + isPartSearch + "&removeDateRestriction=" + removeDateRestriction
    return axios.get(reqUrl)
  },
  GetClaimReasons: function () {
    let reqUrl = window.appGlobals.API_URL + "Claims/GetClaimReasons"
    return axios.get(reqUrl)
  },
  GetClaimPartImageUrls: function (claimItems) {
    let reqUrl = window.appGlobals.API_URL + "Claims/ClaimPartImageUrls"
    return axios.post(reqUrl, claimItems)
  },
  SubmitClaim: function(accountId, userId, claimDto) {
    let reqUrl = window.appGlobals.API_URL + "Claims/SubmitClaim?accountId=" + accountId + "&userId=" + userId;
    return axios.post(reqUrl, claimDto);
  },
  LoadClaimInvoiceItems: function (accountId, userId, invoiceId, invoiceSource) {
    let reqUrl = window.appGlobals.API_URL + "Claims/LoadClaimInvoiceItems"
    return axios.get(reqUrl, {
      params: {
        accountId: accountId,
        userId: userId,
        invoiceId: invoiceId,
        invoiceSource: invoiceSource
      }
    })
  },
  GetClaimsFilingInstructionsTitle: function(){
    var reqUrl = window.appGlobals.API_URL + "Returns/ClaimFilingInstructionsTitle";
    return axios.get(reqUrl);
  },
  GetClaimsFilingInstructionsUrl: function(title){
    var returnUrl = "";
    if(title != "") {
      returnUrl = window.appGlobals.PART_IMAGES_API_URL + "Media/FileByTitle?title=" + title;
    }
    return returnUrl;
  },
  async SaveClaimsMediaFile(formData) {
    let filename = ""
    let reqUrl = window.appGlobals.API_URL + "Returns/SaveClaimMediaFile";

    const response = await axios.post(reqUrl, formData )
    .then((response) => {
      filename = response.data;
    })
    .catch((error) => {
      // set file name to "ERROR" then send response to user. Logged from web api
      filename = "ERROR";
    });

    return filename;
  },
 async GetClaimAllowedDays(mcfCostCenterId){
    var reqUrl = window.appGlobals.API_URL + "Claims/GetClaimAllowedDays?mcfCostCenterId=" + mcfCostCenterId;
    var response = await axios.get(reqUrl);
    return response.data;
  }
})
